import React from 'react'
import CreateCollectionForm from "./CreateCollectionForm"
export default function Index() {
  return (
    <div>
      <CreateCollectionForm />
    </div>
  )
}
